<template>
    <div>
        <input-text
            :name="'email'"
            :id="'email'"
            type="email"
            v-model="GET_USER.email"
            :label="'E-Mail'"
            :labelClass="'bg-white'"
            class="mb-5 mt-1 w-full xs:w-64"
            @change="$emit('change', GET_USER)"
        />
        <div class="relative h-8">
            <div
                class="absolute left-0 top-0 flex flex-row justify-start items-center cursor-pointer transform transition-all hover:scale-105 "
                @click="changeShowPassword"
            >
                <lock-closed-icon
                    :fillClass="'fill-primary'"
                    v-if="state.showPassword == false"
                />
                <lock-icon :fillClass="'fill-primary'" v-else />
                <div
                    class="font-semibold text-base text-primary ml-4 select-none"
                >
                    {{
                        state.showPassword == false
                            ? "Passwort ändern"
                            : "Abbrechen"
                    }}
                </div>
            </div>
        </div>
        <fade-transition>
            <div
                v-if="state.showPassword"
                class="w-full opacity-100 transition-all mt-5"
            >
                <input-text
                    :name="'password_old'"
                    :id="'password_old'"
                    v-model="GET_USER.password_old"
                    :label="'Altes Passwort'"
                    :labelClass="'bg-white'"
                    :type="'password'"
                    class="w-full xs:w-64 mt-5"
                />
                <error-feedback-text
                    :name="'password_old'"
                    class="mb-2"
                ></error-feedback-text>
                <input-text
                    :name="'password_new'"
                    :id="'password_new'"
                    v-model="GET_USER.password_new"
                    :label="'Neues Passwort'"
                    :labelClass="'bg-white'"
                    :type="'password'"
                    class="w-full xs:w-64 mt-5"
                />
                <error-feedback-text
                    :name="'password_new'"
                    class="mb-2"
                ></error-feedback-text>
                <input-text
                    :name="'password_new_confirmation'"
                    :id="'password_new_confirmation'"
                    v-model="GET_USER.password_new_confirmation"
                    :label="'Passwort wiederholen'"
                    :labelClass="'bg-white'"
                    :type="'password'"
                    class="w-full xs:w-64 mt-5"
                />
                <error-feedback-text
                    :name="'password_new_confirmation'"
                    class="mb-2"
                ></error-feedback-text>
                <custom-button
                    @click="$emit('changePassword', GET_USER)"
                    class="w-full xs:w-64 h-11 mt-10"
                    :text="'Passwort ändern'"
                    :bgColor="'bg-primary'"
                    :textColor="'text-white'"
                    :id="'save-password-button'"
                /></div
        ></fade-transition>
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import { useStore } from "vuex";
import ErrorFeedbackText from "../../components/helper/ErrorFeedbackText.vue";
import CustomButton from "../../components/input/CustomButton.vue";
import InputText from "../../components/input/InputText.vue";
import FadeTransition from "../../components/transitions/FadeTransition.vue";
import { AUTH_USER_TYPES, STORE_TYPES } from "../../store/types";

export default defineComponent({
    name: "SettingsForm",
    components: { InputText, CustomButton, FadeTransition, ErrorFeedbackText },
    emits: ["change", "changePassword"],

    setup() {
        const store = useStore();
        const state = reactive({ showPassword: false });

        function changeShowPassword() {
            delete GET_USER.value.password_old;
            delete GET_USER.value.password_new;
            delete GET_USER.value.password_new_confirmation;
            state.showPassword = !state.showPassword;
        }

        const GET_USER = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.AUTH_USER}/${AUTH_USER_TYPES.GET_USER}`
                ]
        );
        return { state, GET_USER, changeShowPassword };
    },
});
</script>
